<section class="container-nm w-100 mx-auto step_mobile" style="box-sizing: border-box;">
<div class="title-page">
    @if(roomInfo.maximum_players > 1){
        <span>{{roomInfo.name}}</span>
    }@else{
        <span>{{ 'gameInfo.txtPrepGame' | translate }}</span>
    }
</div>
<div class="line"></div>
<div class="description-page d-flex align-items-center justify-content-center" [attr.data-mp]="roomInfo.maximum_players" [attr.data-wait]="userWait(roomInfo.maximum_players)">
    @if(roomInfo.maximum_players > 1){
        <!-- && userWait(roomInfo.maximum_players) -->
         @if(players.player.is_starter){
            @if(userWait(roomInfo.maximum_players)){
                <svg class="loader" width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.07129 0.95456C8.07129 0.406337 8.51648 -0.0423519 9.06283 0.00294583C10.692 0.138023 12.2801 0.604935 13.7281 1.37886C15.4684 2.30912 16.9526 3.65424 18.0489 5.29507C19.1453 6.9359 19.8201 8.8218 20.0135 10.7857C20.2069 12.7496 19.913 14.7309 19.1578 16.5541C18.4027 18.3773 17.2095 19.9861 15.684 21.238C14.1585 22.49 12.3479 23.3463 10.4124 23.7313C8.47688 24.1163 6.47631 24.018 4.58788 23.4452C3.0168 22.9686 1.56368 22.1758 0.316148 21.1193C-0.10221 20.765 -0.0997355 20.1329 0.287917 19.7453C0.675569 19.3576 1.30124 19.362 1.72535 19.7094C2.73782 20.5387 3.90565 21.1636 5.16418 21.5454C6.74019 22.0235 8.40978 22.1055 10.0251 21.7842C11.6403 21.4629 13.1515 20.7482 14.4246 19.7034C15.6976 18.6586 16.6934 17.3159 17.3237 15.7944C17.9539 14.2728 18.1992 12.6193 18.0378 10.9803C17.8763 9.3413 17.3132 7.76741 16.3982 6.39804C15.4832 5.02867 14.2446 3.90609 12.7922 3.12973C11.6323 2.50977 10.3647 2.12587 9.06233 1.99636C8.5168 1.94211 8.07129 1.50278 8.07129 0.95456Z" fill="url(#paint0_linear_199_1602)"/>
                    <defs>
                    <linearGradient id="paint0_linear_199_1602" x1="8.07129" y1="-0.0380859" x2="0.928431" y2="20.4925" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0918203" stop-color="#71C55D" stop-opacity="0"/>
                    <stop offset="1" stop-color="#71C55D"/>
                    </linearGradient>
                    </defs>
                </svg>
                @if (roomInfo.number_of_players === 1) {
                    <span>{{ 'lobby.txtWaitPlayer' | translate }}</span>
                }@else{
                    @if (roomInfo.number_of_players >= 2) {
                        @if(roomInfo.maximum_players === 2){
                            <span>{{ 'lobby.txtWaitPlayer' | translate }}</span>
                        }@else{
                            @if(isTwoPlayersIsReady()){
                                <span>{{ 'lobby.txtWait' | translate }}</span>
                            }@else{
                                <span>{{ 'lobby.txtWaitPlayer' | translate }}</span>
                            }
                        }
                    }
                    
                }
            }@else{
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5501 18.0001L3.8501 12.3001L5.2751 10.8751L9.5501 15.1501L18.7251 5.9751L20.1501 7.4001L9.5501 18.0001Z" fill="#71C55D"/>
                </svg>
                <span>{{ 'lobby.txtEndWait' | translate }}</span>
            }
         }@else{
            @if(userWait(roomInfo.maximum_players)){
               <svg class="loader" width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.07129 0.95456C8.07129 0.406337 8.51648 -0.0423519 9.06283 0.00294583C10.692 0.138023 12.2801 0.604935 13.7281 1.37886C15.4684 2.30912 16.9526 3.65424 18.0489 5.29507C19.1453 6.9359 19.8201 8.8218 20.0135 10.7857C20.2069 12.7496 19.913 14.7309 19.1578 16.5541C18.4027 18.3773 17.2095 19.9861 15.684 21.238C14.1585 22.49 12.3479 23.3463 10.4124 23.7313C8.47688 24.1163 6.47631 24.018 4.58788 23.4452C3.0168 22.9686 1.56368 22.1758 0.316148 21.1193C-0.10221 20.765 -0.0997355 20.1329 0.287917 19.7453C0.675569 19.3576 1.30124 19.362 1.72535 19.7094C2.73782 20.5387 3.90565 21.1636 5.16418 21.5454C6.74019 22.0235 8.40978 22.1055 10.0251 21.7842C11.6403 21.4629 13.1515 20.7482 14.4246 19.7034C15.6976 18.6586 16.6934 17.3159 17.3237 15.7944C17.9539 14.2728 18.1992 12.6193 18.0378 10.9803C17.8763 9.3413 17.3132 7.76741 16.3982 6.39804C15.4832 5.02867 14.2446 3.90609 12.7922 3.12973C11.6323 2.50977 10.3647 2.12587 9.06233 1.99636C8.5168 1.94211 8.07129 1.50278 8.07129 0.95456Z" fill="url(#paint0_linear_199_1602)"/>
                    <defs>
                    <linearGradient id="paint0_linear_199_1602" x1="8.07129" y1="-0.0380859" x2="0.928431" y2="20.4925" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0918203" stop-color="#71C55D" stop-opacity="0"/>
                    <stop offset="1" stop-color="#71C55D"/>
                    </linearGradient>
                    </defs>
                </svg>
                <span>{{ 'lobby.txtWaitPlayerNotStarter' | translate }}</span> 
            }@else {
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5501 18.0001L3.8501 12.3001L5.2751 10.8751L9.5501 15.1501L18.7251 5.9751L20.1501 7.4001L9.5501 18.0001Z" fill="#71C55D"/>
                </svg>
                <span>{{ 'lobby.txtWaitPlayerStarGame' | translate }}</span>
            }
         }
        
        
    }@else {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5501 18.0001L3.8501 12.3001L5.2751 10.8751L9.5501 15.1501L18.7251 5.9751L20.1501 7.4001L9.5501 18.0001Z" fill="#71C55D"/>
        </svg>
        <span>{{ 'lobby.txtWaitOnePlayer' | translate }}</span>
    }
</div>
<div class="block-info-players">
    <div class="d-flex flex-column align-items-start">
        <div class="block-goal-info d-flex flex-column" >
            <div class="goal-info d-flex flex-column" >
                <div class="goal-title">{{ 'targets.txtTilte' | translate }}</div>
                <div class="goal-description">{{ questInfo.data.humman_description.goal }}</div>
            </div>
            <div class="goal-descr-info d-flex flex-column">
                <div class="title d-flex justify-content-between align-items-center w-100">
                            <span>{{ 'targets.txtDescription' | translate }}</span>
                            <span class="d-flex align-items-center justify-content-start btn-goal-info" (click)="showText()">
                                <span>{{ 'playerForm.txtViewFull' | translate }}</span>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.45 9L6 5.55L7.05 4.5L11.55 9L7.05 13.5L6 12.45L9.45 9Z" fill="black" fill-opacity="0.2"/>
                                </svg>
                            </span>
                        </div>
                <div class="goal-descr-description" [innerHTML]="questInfo.data.humman_description.text"></div>
            </div>
        </div>
        @if (roomInfo.maximum_players > 1 && players.player.is_starter) {
            <app-shared [maxPlayers]="roomInfo.maximum_players" [playersLen]="realPlayers.length" [uuid]="uuid" style="width: 100%;"></app-shared>
        }@else{
            <div class="k-line mobile-line"></div>
        } 
        <app-tmp-wt-players-info class="d-flex flex-column align-items-start w-100" [data]="realPlayers" [roomInfo]="roomInfo" [user]="players.player"></app-tmp-wt-players-info>
    </div>
</div>
<app-tmp-wt-finished class="my-23125" [player]="players.player" [roomInfo]="roomInfo" [data]="realPlayers"/>
</section>
